import React from 'react';
import { motion } from 'framer-motion';
import { getCheckoutUrl } from '../utils/getCheckoutUrl';
import { trackAddToCart } from '../utils/metaPixel';
interface HeroSectionProps {
  addedBumps: Record<string, boolean>;
}
export function HeroSection({
  addedBumps
}: HeroSectionProps) {
  return <section id="hero-cta" className="relative min-h-screen flex items-center justify-center px-6 py-32 overflow-hidden" data-id="element-62">
      {/* Subtle animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-63">
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.03, 0.06, 0.03]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/4 left-1/4 w-96 h-96 bg-accent rounded-full blur-3xl" data-id="element-64" />
        <motion.div animate={{
        scale: [1, 1.3, 1],
        opacity: [0.02, 0.05, 0.02]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl" data-id="element-65" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-67">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-text-primary mb-8 leading-tight" data-id="element-68">
            Cómo crear videos virales usando inteligencia artificial{' '}
            <span className="text-accent" data-id="element-69">(aunque empieces desde cero)</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-lg md:text-2xl text-text-secondary mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-70">
          Descubre el sistema simple para crear contenido que llama la atención,
          se comparte y puede crecer en redes.
        </motion.p>

        {/* Price display */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex items-center justify-center gap-4 mb-8" data-id="element-71">
          <span className="text-text-secondary/50 line-through text-2xl md:text-3xl" data-id="element-72">
            €49.99
          </span>
          <span className="text-accent text-4xl md:text-5xl font-bold" data-id="element-73">
            €4.99
          </span>
          <span className="bg-accent/15 text-accent text-sm md:text-base font-bold px-3 py-1 rounded-full" data-id="element-74">
            -90%
          </span>
        </motion.div>

        {/* YouTube Video */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative w-full max-w-2xl mx-auto mb-10 rounded-xl overflow-hidden shadow-2xl shadow-black/40 border border-dark-tertiary" data-id="element-75">
          <div className="relative w-full" style={{
          paddingBottom: '56.25%'
        }} data-id="element-76">
            <iframe src="https://www.youtube.com/embed/twJzGvkWURs?rel=0" title="Video de presentación" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-77" />
          </div>
        </motion.div>

        <motion.a href={getCheckoutUrl(addedBumps)} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-block px-10 py-5 bg-accent text-dark-bg font-bold text-lg rounded-lg hover:bg-accent/90 transition-all shadow-lg shadow-accent/20" data-id="element-78">
          Quiero crear contenido viral
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-4 text-text-secondary/60 text-sm" data-id="element-79">
          Acceso inmediato. Empieza hoy mismo.
        </motion.p>

        {/* Pulsing indicator */}
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.5, 0.8, 0.5]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-accent rounded-full" data-id="element-80" />
      </div>
    </section>;
}